import { render, staticRenderFns } from "./CallWrap.vue?vue&type=template&id=75ac19ee&scoped=true&"
import script from "./CallWrap.vue?vue&type=script&lang=js&"
export * from "./CallWrap.vue?vue&type=script&lang=js&"
import style0 from "./CallWrap.vue?vue&type=style&index=0&id=75ac19ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ac19ee",
  null
  
)

export default component.exports